import Vue from 'vue'


export default {
  name:'intersection-observer',

  bind: function (el, binding, vnode) {

    var intersectEvent = binding.value.intersectEvent || false;
    var intersectClass = binding.value.intersectClass || 'io_visible';
    var intersectRoot   = binding.value.intersectRoot || null;
    if (typeof binding.value.intersectMargin !== 'undefined')
      var intersectMargin = binding.value.intersectMargin;
    else
      var intersectMargin = '0px';
    // var intersectMargin = binding.value.intersectMargin || '0px';
    if (typeof binding.value.intersectThreshold !== 'undefined')
      var intersectThreshold = binding.value.intersectThreshold;
    else
      var intersectThreshold = 0.5;


    let observer;
    let options = {
      root: intersectRoot,
      rootMargin: intersectMargin,
      threshold: intersectThreshold
    };


Vue.nextTick(() => {

    observer = new IntersectionObserver(([entry]) => {
      console.log('IntersectionObserver', entry);

      if (entry.isIntersecting) {
        if (intersectEvent){
            vnode.context.$root.$emit(intersectEvent, {
              entry: entry,
              message: "Intersention observer - isIntersecting"
            });
            console.log('intersection-event',intersectEvent);
        }

        el.classList.add(intersectClass);
        console.log('intersection');
      }
      else{
        if (intersectEvent){
            vnode.context.$root.$emit('not-'+intersectEvent, {
              entry: entry,
              message: "Intersention observer - notIntersecting"
            });
            console.log('not-intersection-event','not-'+intersectEvent);
        }

        el.classList.remove(intersectClass);
        console.log('not-intersection');
      }

    }, options);
    observer.observe(el);

});

  },
  unbind: function () {
    // observer.unobserve(el);
  }

};
